module.exports = __webpack_public_path__ + "static/media/ins20.5f540de6.jpg";